import { requiredDateMessage } from "../validationMessages";
import { dateValidator as dateValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const minDate: Date = new Date(1900, 1, 1);
export const maxDate: Date = new Date();

const yearOnlyRegex = /^[0-9]{4}$/;

export const dateValidatorRequired = trimmedString
  .transform((value, originalValue) => {
    if (originalValue instanceof Date) {
      return originalValue.getFullYear().toString();
    }
    return value;
  })
  .typeError(requiredDateMessage)
  .required(requiredDateMessage)
  .matches(dateValidatorRegex, requiredDateMessage);

export const dateValidator = trimmedString
  .transform((value, originalValue) => {
    if (originalValue instanceof Date) {
      return originalValue.getFullYear().toString();
    }
    return value;
  })
  .nullable()
  .matches(dateValidatorRegex, {
    message: requiredDateMessage,
    excludeEmptyString: true,
  });
